import { constants } from 'lib_ui-services';

export const _private = {};

export default {
    verb: 'doingUpdate',
    namespace: 'application',
    relation: 'runtime',
    type: 'DynamicFieldEntryUsed',
    prerequisites: [],
    useCaseIds: [constants.useCaseIds.RFID, constants.useCaseIds.ASSET_TRACKING],
    description:
        'For RFID use case and Update screen, add all location tier fields if one is added (location, building, company)',
    //this is the actual logic:
    logic: ensureAllLocationTierFieldsAreAdded
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   workflowStack: WorkflowStack[];
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function ensureAllLocationTierFieldsAreAdded({ data, dispatch }) {
    const { childHNode, allowedEntries } = data;
    // Check if the field is a location tier field
    if (childHNode.foreignNamespace !== 'location') return;
    // Find any other location hNodes not already in the entries
    const otherLocationHNodesToAdd = allowedEntries.filter(
        entry => entry.foreignRelation !== childHNode.foreignRelation && entry.foreignNamespace === 'location'
    );
    // Inform the DynamicFieldEntry component that these entries should be added
    otherLocationHNodesToAdd.forEach(hNode => {
        dispatch(hNode, { verb: 'AddDynamicFieldEntry', namespace: 'application', relation: 'runtime' });
    });
}
